import React, { ComponentProps } from 'react'
import SvgIcon from '@mui/material/SvgIcon'

export const YahooLogo = ({ width = 24, height = 24, ...restProps }: ComponentProps<typeof SvgIcon>) => (
  <SvgIcon {...restProps} viewBox={`0 0 ${width} ${height}`}>
    <path
      d="M4.5 2.5C4.5 2.5 5.2 2.65 5.75 2.65C6.3 2.65 7 2.5 7 2.5L12 11L17.05 2.5C17.05 2.5 17.6 2.7 18.25 2.7C18.95 2.7 19.5 2.5 19.5 2.5L13 13.5L13.2 21.5C13.2 21.5 12.5 21.3 12 21.3C11.5 21.3 10.75 21.5 10.75 21.5L11 13.5L4.5 2.5Z"
      fill="#673AB7"
    />
  </SvgIcon>
)
